// PRODUCTION — admin flow editor constants
import { CollectDataStepType } from 'src/constants/collect-data/enums'
import { StepApprovalType } from 'src/interfaces/onboardingTemplate'
import { BasicSelectOption } from 'src/components/shared/form/BasicSelect'

export const STEP_CATEGORIES = [
  {
    label: 'Identity & Documents',
    types: [
      CollectDataStepType.DriverLicense,
      CollectDataStepType.PIICollection,
      CollectDataStepType.EIN,
    ],
  },
  {
    label: 'Insurance',
    types: [
      CollectDataStepType.InsuranceCoverage,
      CollectDataStepType.InsuranceDeclaration,
      CollectDataStepType.InsuranceBeneficiary,
      CollectDataStepType.VehicleInsurance,
      CollectDataStepType.VehicleRegistration,
    ],
  },
  {
    label: 'Compliance',
    types: [
      CollectDataStepType.BGC,
      CollectDataStepType.MVR,
      CollectDataStepType.MCNumber,
      CollectDataStepType.DOTNumber,
    ],
  },
  {
    label: 'Payments',
    types: [CollectDataStepType.PaymentMethod],
  },
  {
    label: 'Training & Legal',
    types: [
      CollectDataStepType.LMSTraining,
      CollectDataStepType.SignContract,
      CollectDataStepType.Form,
    ],
  },
]

export const APPROVAL_TYPE_OPTIONS: BasicSelectOption[] = [
  { label: 'Auto Approval', value: StepApprovalType.AutoApproval },
  { label: 'Customer Approval', value: StepApprovalType.CustomerApproval },
  { label: 'Internal Approval', value: StepApprovalType.InternalApproval },
  { label: 'Internal → Customer', value: StepApprovalType.InternalThenCustomerApproval },
  { label: 'Customer → Internal', value: StepApprovalType.CustomerThenInternalApproval },
]

export const YARDSTIK_PACKAGE_OPTIONS: BasicSelectOption[] = [
  { label: 'Boks Zn 1 - Candidate Pay', value: 'Boks Zn 1 - Candidate Pay' },
  { label: 'Boks Zn 1 - Employer Pay', value: 'Boks Zn 1 - Employer Pay' },
  { label: 'Boks Zn 2 - Candidate Pay', value: 'Boks Zn 2 - Candidate Pay' },
  { label: 'Boks Zn 2 - Employer Pay', value: 'Boks Zn 2 - Employer Pay' },
  { label: 'Boks Master - Candidate Pay', value: 'Boks Master - Candidate Pay' },
  { label: 'Boks Master - Employer Pay', value: 'Boks Master - Employer Pay' },
]

export const POLICY_PRODUCT_OPTIONS: BasicSelectOption[] = [
  { label: 'GigSafe Basic', value: 'GigSafe Basic' },
  { label: 'GigSafe Plus', value: 'GigSafe Plus' },
  { label: 'GigSafe Pro', value: 'GigSafe Pro' },
  { label: 'Commercial Auto', value: 'Commercial Auto' },
  { label: 'Occupational Accident', value: 'Occupational Accident' },
]
